import { cn } from "@/lib/utils";

interface PageSpinnerProps {
  /**
   * Fill the viewport (`min-h-screen`) instead of the parent (`h-full`).
   * Use it for guards that render before any layout exists, e.g. while the
   * session is resolving.
   */
  fullScreen?: boolean;
}

/** Centred loading spinner for a page or route guard that is still resolving. */
export function PageSpinner({ fullScreen = false }: Readonly<PageSpinnerProps>) {
  return (
    <div
      data-testid="page-spinner"
      className={cn(
        "flex items-center justify-center",
        fullScreen ? "min-h-screen" : "h-full",
      )}
    >
      <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary"></div>
    </div>
  );
}
